import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { eventList } from "Apis/event";
import { getJsonData } from "Apis/utils";

export const AdvertisementContext = createContext();

export const AdvertisementContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [eventDataList, setEventDataList] = useState([]);
  const [advertisementPage, setAdvertisementPage] = useState([]);

  const getEventApi = async () => {
    let response = await eventList();
    if (response?.status === 200) {
      setEventDataList(
        response.data.data.rows?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.title,
        }))
      );
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  // Json Listing
  const jsonListing = async () => {
    let data = await getJsonData();
    if (data?.status === 200) {
      const advertisementPageOptions = data?.data?.data?.advertisementPageData?.map((tag) => ({
        label: tag.label,
      }));
      setAdvertisementPage(advertisementPageOptions);
    }
  };

  return (
    <AdvertisementContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        getEventApi,
        eventDataList,
        setEventDataList,
        advertisementPage,
        jsonListing,
      }}
    >
      {children}
    </AdvertisementContext.Provider>
  );
};

export default AdvertisementContextProvider;
AdvertisementContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
